import { QUICK_FILTER_PAGE_IDS } from "../quickFilterUtils";
import { createSystemPresetsFromRules } from "./createSystemPresetsFromRules";

const PAGE_ID = QUICK_FILTER_PAGE_IDS.BID_ADJUST_V2;

const AMAZON_RULES = [
  {
    section: "metrics",
    id: "spend_gt_0",
    name: "Spend > 0",
    member: "spends",
    operator: "gt",
    values: [0],
  },
  {
    section: "dimension",
    id: "campaign_status_enabled",
    name: "Campaign Status = Enabled",
    member: "campaign_status",
    operator: "equals",
    values: ["ENABLED"],
  },
  {
    section: "dimension",
    id: "bid_strategy_down",
    name: "Bid Strategy = Down",
    member: "campaign_bid_strategy",
    operator: "equals",
    values: ["Down"],
  },
  {
    section: "metrics",
    id: "current_bid_gt_30",
    name: "Current Bid > 30",
    member: "bid_adjustment_value",
    operator: "gt",
    values: [30],
  },
  {
    section: "dimension",
    id: "placement_top_of_search",
    name: "Placement = Top of Search",
    member: "placement_name",
    operator: "equals",
    values: ["Top of Search"],
  },
];

const BID_ADJUST_V2_PRESETS = {
  amazon: createSystemPresetsFromRules(PAGE_ID, "amazon", AMAZON_RULES),
};

export default BID_ADJUST_V2_PRESETS;
